<template>
  <van-nav-bar
    left-text="返回"
    @click="$router.go(-1)"
    left-arrow
    title="我的订单"
  />
  <div class="my_order">
    <div inset v-for="(item, index) in Orders" :key="index">
      <div class="order_items">
        <div class="order_items_title">
          <div class="order_items_number">{{ item.OrderNumber }}</div>
          <div class="order_items_total">合计:{{ item.TotalFormat }}</div>
        </div>
        <div class="order_items_content">
          <div
            class="order_items_detail"
            v-for="OrderItem in item.ShoppingOrderItems"
            :key="OrderItem.Id"
          >
            <div class="order_items_img">
              <img :src="OrderItem.ImageFormet" />
            </div>
            <div class="productCollection_name" @click="DetailOrder(OrderItem)">
              <van-icon name="label-o" />{{ item.Name }}
            </div>
            <div class="order_items_name">{{ OrderItem.Name }}</div>
            <div class="order_items_Price">
              <div class="price">{{ OrderItem.PriceFormat }}</div>
              <div class="count">共{{ OrderItem.Count }}件</div>
              <div
                class="count"
                @click="CollectionDetail(OrderItem)"
                v-if="OrderItem.ProductType == 200"
              >
                查看详细
              </div>
            </div>

            <!-- <van-image width="50" height="50" :src="OrderItem.ImageFormet" /> -->
          </div>
          <div class="order_items_amountdetail">
            <div>共{{ item.ShoppingOrderItems.length }}件</div>
            <div>税额:{{ item.TaxAmountFormat }}</div>
            <div>金额:{{ item.AmountFormat }}</div>
            <div>合计:{{ item.TotalFormat }}</div>
          </div>

          <div class="order_items_status">
            <div class="order_items_status_item">
              <div class="title">支付方式:</div>
              <div class="value">{{ item.PayWayFormat }}</div>
            </div>
            <div class="order_items_status_item">
              <div class="title">货运方式:</div>
              <div class="value">{{ item.FreightTransportFormat }}</div>
            </div>
            <div class="order_items_status_item">
              <div class="title">支付手续费:</div>
              <div class="value">{{ item.PayChargeForTroubleFormat }}</div>
            </div>
            <div class="order_items_status_item">
              <div class="title">支付状态:</div>
              <div class="value">{{ item.PaySatausFormat }}</div>
            </div>
            <div class="order_items_status_item" v-if="item.PaySataus == 100">
              <div class="title">支付时间:</div>
              <div class="value">{{ item.PayTimeFormat }}</div>
            </div>
            <div class="order_items_status_item">
              <div class="title">订单状态:</div>
              <div class="value">{{ item.OrderStatusFormat }}</div>
            </div>
            <div class="order_items_status_item">
              <div class="title">下单时间:</div>
              <div class="value">{{ item.CreateTimeFormat }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <p class="not_orders">没有更多了...</p>
  </div>

  <!-- 套餐信息 -->
  <van-action-sheet v-model:show="CollectionDetailWindow" title="套餐信息">
    <orderCollectionItem
      :Model="CartItemOpt"
      @GetShoppingCart="GetShoppingCartComplete"
    />
  </van-action-sheet>

  <!-- 详细信息 -->
  <van-action-sheet v-model:show="DetailOrderWindow" title="详细信息">
    <AttributeParamsMoudule :Model="CartItemOpt" />
  </van-action-sheet>
</template> 
<script >
import tabbar from "../../components/tabbars/tabbar.vue";
import axios from "../../commons/AxiosMethod.js";
import axiosfile from "axios";
import orderCollectionItem from "../../components/orderCollectionItem.vue";
import AttributeParamsMoudule from "../../components/AttributeParamsMoudule.vue";

export default {
  data() {
    return {
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      UserIsAuthenticated: true, //用户是否登录
      UserInfo: {}, //用户信息
      Orders: [], //订单列表
      CartItemOpt: {}, //选中
      CollectionDetailWindow: false, //套餐信息
      DetailOrderWindow: false, //详细信息
    };
  },
  name: "App",
  mounted() {
    this.UploadImageUrl = axios.GetUrl() + "/api/Upload/ImageFile";
    this.UploadPictureImageUrl =
      axios.GetUrl() + "/api/Upload/UploadPictureSuccess";
    this.headersImage = {
      Authorization: localStorage.getItem("Authentication_Header"),
    };

    this.GetUserInfo();
    this.GetOrderList();
  },
  components: {
    tabbar,
    orderCollectionItem,
    AttributeParamsMoudule
  },
  methods: {
    //详细信息
    DetailOrder(item) {
      this.CartItemOpt = item; 
      this.DetailOrderWindow = true;
    },
    //套餐详细
    CollectionDetail(item) {
      this.CollectionDetailWindow = true;
      this.CartItemOpt = item;
    },
    //获取用户信息
    GetUserInfo() {
      var param = {};
      axios.apiMethod("/api/User/GetUserInfo", "get", param, (result) => {
        if (result.Code == 200) {
          this.UserInfo = result.Data;
        }
      });
    },
    //订单列表
    GetOrderList() {
      var param = {};
      axios.apiMethod("/Orders/Order/GetOrderList", "get", param, (result) => {
        if (result.Code == 200) {
          this.Orders = result.Data;
        }
      });
    },
  },
};
</script>
 
 
<style lang="scss" scoped>
.order_items {
  width: calc(100% - 20px);
  border: 1px solid #eee;
  margin: 0 auto;
  margin-top: 10px;
  padding: 5px;
  background: #fff;
  border-radius: 8px;
  .order_items_title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px #dbdbdb solid;
    font-size: 10pt;

    .order_items_number {
      padding: 5px 10px;
    }
    .order_items_total {
      padding: 5px 10px;
    }
  }

  .order_items_content {
    padding: 5px;
    .order_items_detail {
      display: flex;
      justify-content: space-between;
      padding: 5px;
      border-bottom: 1px solid #eee;
      margin-top: 5px;
      .order_items_img {
        border: 1px solid #eee;
        padding: 3px;
        img {
          width: 50px;
          height: 50px;
        }
      }
      .order_items_name {
        width: 150px;
        height: 50px;
        padding: 5px;
        font-size: 9pt;
      }
      .order_items_Price {
        width: calc(100% - 230px);
        text-align: center;
        .price {
          font-size: 13pt;
          color: #666;
        }
        .count {
          font-size: 9pt;
        }
      }
    }

    .order_items_amountdetail {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #eee;
      padding: 5px;
      font-size: 10pt;
    }
    .order_items_status {
      padding: 10px;
      .order_items_status_item {
        display: flex;
        justify-content: space-between;
        font-size: 12pt;
        margin-top: 5px;
      }
    }
  }
}
.not_orders {
  text-align: center;
  padding: 10px;
}
</style>
